export const NOTIFICATIONS = ["NOTIFICATIONS"];
